import axios from "axios";
import {localStorageItem} from './../../../../utils/LocalStorage';
import {KEY_LOCALSTORAGE} from "../../../../auth/core/_consts";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_KE_HOACH = API + "/tech-transfer-info";

export const addPhieuKeHoach = (data: any) => {
  let url = API_KE_HOACH;
  return axios.post(url, data);
};
export const updatePhieuKeHoach = (id: string, data: any) => {
  let url = API_KE_HOACH + `/${id}`;
  return axios.put(url, data);
};

export const searchPhieuKeHoach = (searchData: any) => {
  const url = `${API}` + `/tech-transfer-info/search`;
  return axios.post(url, searchData);
};

export const deletePhieuKeHoach = (trackerCode: string, id: string) => {
  const url = `${API_KE_HOACH}` + `/${trackerCode}/${id}`;
  return axios.delete(url);
};

export const searchOptionNhanVien = (searchData: any) => {
  const url = `${API}` + `/obs-complex-categories/danhmucnhanvien/search`;
  return axios.post(url, searchData);
};

export const searchOptionVaiTro = (searchData: any) => {
  const url = `${API}` + `/obs-complex-categories/dohadmvaitro/search`;
  return axios.post(url, searchData);
};

export const updateListCaBenh = (id: number, searchData: any) => {
  const url = `${API}` + `/tech-transfer-follow-up/upsert-list?techTransferInfoId=${id}`;
  return axios.post(url, searchData);
};

export const getListCaBenh = (id: number) => {
  const url = `${API}` + `/tech-transfer-follow-up?techTransferInfoId=${id}`;
  return axios(url);
};
